/**
 * Which cached lists a write refreshes.
 *
 * A review pane or a lookup row is handed its list's query key, and that
 * key ends with the screen's filter (the status tab, the lookup type).
 * An approve or an edit changes the list on every filter, and the person
 * may switch filter while the request runs, so a write refreshes the
 * list's family: the key's first two elements, which name the list and
 * never the filter. React Query invalidates by prefix.
 *
 * The three filtered lists build their keys here, and both the page's
 * read and the tests use these builders, so a key whose shape moves the
 * filter into the first two elements goes red in refreshFamily.test.ts.
 */

export type QueryKey = readonly unknown[];

/** The key's family: its first two elements. */
export function refreshFamily(key: QueryKey): QueryKey {
  return key.slice(0, 2);
}

/** The suggestions queue's list, by kind and status tab. */
export function suggestionsQueueKey(kind: 'edits' | 'resources', tenantSlug: string | undefined, status: string) {
  return ['suggestions-queue', kind, tenantSlug, status] as const;
}

/** The person's own suggestions, by status tab. */
export function mySuggestionsKey(tenantSlug: string | undefined, userId: string | null | undefined, status: string) {
  return ['my-suggestions', tenantSlug, userId, status] as const;
}

/** The lookups admin list, by type and whether deprecated rows show. */
export function lookupsAdminKey(tenantSlug: string | undefined, type: string, includeDeprecated: boolean) {
  return ['lookups-admin', tenantSlug, type, includeDeprecated] as const;
}
